import type { ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'

type SideMenuItemProps = {
  icon: ReactNode
  name: ParseKeys
  href: string
  className?: string
}

export function SideMenuItem({
  icon,
  name,
  href,
  className,
  ...rest
}: SideMenuItemProps): ReactNode {
  const { t } = useTranslation()

  return (
    <Link
      href={href}
      className={twMerge('flex items-center text-text-primary', className)}
      {...rest}
    >
      <div className="mr-3 flex w-6 justify-center">{icon}</div>
      {t(name)}
    </Link>
  )
}
